import React from "react";
import LegalShell from "@/components/LegalShell";

export default function Remboursement() {
  return (
    <LegalShell title="Politique de remboursement" lastUpdated="6 février 2026" testId="page-refund">
      <h2>Principe général</h2>
      <p>Student Hub propose un abonnement Premium au tarif de 2,99 € TTC par mois, sans engagement. Conformément à la réglementation française et européenne, les conditions de remboursement sont les suivantes.</p>

      <h2>Essai gratuit 7 jours</h2>
      <ul>
        <li>L'essai est offert à la première souscription, ne nécessite pas de carte bancaire et n'est pas renouvelable.</li>
        <li>Aucun débit n'est effectué pendant l'essai.</li>
        <li>À l'issue des 7 jours, l'accès Premium expire automatiquement sauf si l'utilisateur a souscrit l'abonnement payant.</li>
      </ul>

      <h2>Annulation de l'abonnement payant</h2>
      <ul>
        <li>L'utilisateur peut annuler son abonnement à tout moment depuis son espace ou via le service de paiement (Stripe, PayPal).</li>
        <li>L'annulation prend effet à la fin de la période en cours. L'accès Premium reste actif jusqu'à cette date.</li>
        <li>Aucune somme déjà prélevée pour la période en cours n'est remboursée, sauf cas de rétractation (voir <a href="/legal/retractation">droit de rétractation</a>).</li>
      </ul>

      <h2>Demande de remboursement exceptionnelle</h2>
      <p>Une demande de remboursement peut être adressée par email à <strong>contact.servicedecomdu64@gmail.com</strong>, dans les cas suivants :</p>
      <ul>
        <li>Indisponibilité du Service supérieure à 48 heures consécutives ;</li>
        <li>Erreur de facturation imputable à l'éditeur ;</li>
        <li>Double prélèvement (cas exceptionnel).</li>
      </ul>
      <p>Toute demande sera étudiée sous 14 jours ouvrés. Le remboursement, s'il est accordé, est effectué par le même moyen de paiement que l'achat initial sous 14 jours supplémentaires.</p>

      <h2>Code promotionnel</h2>
      <ul>
        <li>L'abonnement Premium est facturé 2,99 €/mois et reste accessible jusqu'à la fin de la période payée en cas d'annulation.</li>
        <li>Ils ne sont ni cumulables ni remboursables en cas d'annulation.</li>
      </ul>

      <h2>Litiges</h2>
      <p>En cas de litige non résolu à l'amiable, l'utilisateur peut recourir à la plateforme européenne de règlement en ligne (RLL) : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr</a>.</p>
    </LegalShell>
  );
}
